import { useEffect, useState } from "react";
import { Box, Paper, Text, Image, Center } from "@mantine/core";
import rocketImg from "../../static/images/rocket.png";
import applogo from "../../static/images/applogo.jpg";



export function Maintenance({ reason, minutes, created_date, maintenance_type, platform   }) {
    const parseDuration = (value) => {
    if (!value) return 0;

    const val = String(value).toLowerCase();

    if (val.endsWith("m")) {
      return parseInt(val) * 60; // minutes → seconds
    }

    return parseInt(val) * 3600; // hours → seconds
  };

  // Convert to seconds
  const durationSeconds = parseDuration(minutes);
const endTime =
    new Date(created_date).getTime() + durationSeconds * 1000;
  const now = new Date().getTime();
  const diffSeconds = Math.max(0, Math.floor((endTime - now) / 1000));

  const [count, setCount] = useState(diffSeconds); // Convert minutes to seconds

  // When timer reaches 0 → reload app
// useEffect(() => {
//   if (count === 0) {
//     window.location.reload();
//   }
// }, [count]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCount(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = () => {
    const hours = Math.floor(count / 3600);
    const minutes = Math.floor((count % 3600) / 60);
    const seconds = count % 60;

    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

const showVisitWebsite =
  platform === "app" && maintenance_type === "app";

const showOpenApp =
  platform === "web" && maintenance_type === "website";


  return (
    <Center style={{ height: "100vh", background: "#e9ecff" }}>
      <Paper
        shadow="md"
        p={30}
        radius={20}
        style={{
          maxWidth: 480,
          width: "90%",
          textAlign: "center",
        }}
      >
        <Center>
  <Box
    style={{
      width: 100,
      height: 100,
      borderRadius: "50%",
      overflow: "hidden",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "rgb(0 163 81)",
    }}
  >
    <Image
      src={applogo}
      width={70}
      height={70}
      fit="contain"
    />
  </Box>
</Center>


        <Text
          size={28}
          weight={700}
          mt={15}
          color="#2d8c3b" // Quzone green
        >
          We'll Be Back Soon
        </Text>

        <Text size="sm" mt={10}>
          {reason || "Scheduled maintenance is in progress."}
        </Text>

        <Image
          src={rocketImg}
          width={180}
          mt={25}
          mb={15}
          style={{ margin: "auto" }}
        />

        <Text mt={15} size="sm">
          Thank you for your patience.
        </Text>

        <Text
          mt={20}
          size={40}
          weight={700}
          color="#2d8c3b"
        >
          {formatTime()} Hrs
        </Text>
        {/* WEBSITE LINK (APP → WEBSITE) */}
{showVisitWebsite && (
  <a
    href="https://www.quzone.in"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: "inline-block",
      marginTop: 20,
      padding: "10px 20px",
      background: "#2d8c3b",
      color: "white",
      borderRadius: 10,
      textDecoration: "none",
      fontWeight: 600
    }}
  >
    Visit Website
  </a>
)}

{/* APP LINK (WEBSITE → APP) */}
{showOpenApp && (
  <a
    href="https://play.google.com/store/apps/details?id=com.postulate.quzone&hl=en_IN"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: "inline-block",
      marginTop: 20,
      padding: "10px 20px",
      background: "#2d8c3b",
      color: "white",
      borderRadius: 10,
      textDecoration: "none",
      fontWeight: 600
    }}
  >
    Open App
  </a>
)}

      </Paper>
    </Center>
  );
}


